import type { SVGProps } from 'react';
import * as React from 'react';

const DxfIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={40} height={44} viewBox="0 0 40 44" fill="none" aria-hidden="true" {...props}>
    <g id="file-icon/dxf">
      <g id="Vector" filter="url(#filter0_dd_3816_38109)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.2223 1L35.3334 10.1111V38.3333C35.3334 39.8061 34.1505 41 32.6777 41C27.0142 41 13.7443 41 7.32677 41C5.85401 41 4.66675 39.82 4.66675 38.3473C4.66675 30.3468 4.66675 10.7752 4.66675 3.6498C4.66675 2.17704 5.86066 1 7.33341 1H26.2223Z"
          fill="#1F2937"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.2223 1L35.3334 10.1111V38.3333C35.3334 39.8061 34.1505 41 32.6777 41C27.0142 41 13.7443 41 7.32677 41C5.85401 41 4.66675 39.82 4.66675 38.3473C4.66675 30.3468 4.66675 10.7752 4.66675 3.6498C4.66675 2.17704 5.86066 1 7.33341 1H26.2223Z"
          fill="url(#paint0_radial_3816_38109)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.2223 1L26.2223 7.44444C26.2223 8.9172 27.4162 10.1111 28.889 10.1111L35.3334 10.1111L26.2223 1Z"
          fill="white"
          fillOpacity={0.3}
        />
      </g>
      <path
        id="Vector_2"
        d="M22.8336 16.6009L29.0405 31.1537H24.0291L17.3604 15.7249L18.702 20.1049L15.6241 27.6418L12.3884 27.918H21.4642L15.5487 30.4381C13.9768 31.1077 12.1638 30.3313 11.5639 28.7315L11.3068 28.046C11.0384 27.3302 11.0534 26.5388 11.3487 25.8337L15.2082 16.6189C15.6753 15.5037 16.7662 14.7778 17.9753 14.7778H20.0742C21.2761 14.7778 22.3621 15.4953 22.8336 16.6009Z"
        fill="white"
      />
      <g id="border">
        <path
          d="M7.33691 1.5H26.0186L34.8369 10.3184V38.333C34.8369 39.5323 33.8746 40.5 32.6807 40.5H7.33008C6.20656 40.5 5.29068 39.6581 5.18066 38.5684L5.16992 38.3477V3.64941C5.17013 2.4571 6.13628 1.5 7.33691 1.5Z"
          stroke="black"
          strokeOpacity={0.06}
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_dd_3816_38109"
        x={2.66675}
        y={0}
        width={34.6667}
        height={44}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={0.5} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3816_38109" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="effect1_dropShadow_3816_38109" result="effect2_dropShadow_3816_38109" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_3816_38109" result="shape" />
      </filter>
      <radialGradient
        id="paint0_radial_3816_38109"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(20.0001 0.999999) rotate(90) scale(40 40.1825)"
      >
        <stop offset={0.297418} stopOpacity={0} />
        <stop offset={1} stopOpacity={0.08} />
      </radialGradient>
    </defs>
  </svg>
);
export default DxfIcon;
